import { render, staticRenderFns } from "./friendlink.vue?vue&type=template&id=6ceb60e6&scoped=true&"
import script from "./friendlink.vue?vue&type=script&lang=js&"
export * from "./friendlink.vue?vue&type=script&lang=js&"
import style0 from "./friendlink.vue?vue&type=style&index=0&id=6ceb60e6&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb60e6",
  null
  
)

export default component.exports